import { render, staticRenderFns } from "./FavPatentRemindList.vue?vue&type=template&id=008739e6"
import script from "./FavPatentRemindList.vue?vue&type=script&lang=ts"
export * from "./FavPatentRemindList.vue?vue&type=script&lang=ts"
import style0 from "./FavPatentRemindList.vue?vue&type=style&index=0&id=008739e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports